import { createContext } from 'react';
import { SchedulerFlowsForExperiments_schedulerFlowsByCompanyId } from 'types/apollo/SchedulerFlowsForExperiments';

export interface OutreachTemplatesContextProps {
  options: SchedulerFlowsForExperiments_schedulerFlowsByCompanyId[];
}

export const OutreachTemplatesContext = createContext<OutreachTemplatesContextProps>({
  options: [],
});
